import { supabase } from '../supabaseClient';
import { API_URL } from './config';

/**
 * Authenticated ping: sends a body to the backend, which echoes it back.
 * Throws if the user is not signed in or the request fails.
 */
export async function ping(payload: unknown) {
  const session = await supabase.auth.getSession();
  const token = session.data.session?.access_token;

  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await fetch(`${API_URL}/api/ping`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error ?? `Ping failed (${response.status})`);
  }

  return await response.json();
}
